import React from "react"
import NImage, { ImageProps } from "next/image";
import { Property } from "csstype";

export const NextImage = ({ src, width, size, objectFit, objectPosition, ...rest }: ImageProps & {
  size?: number
  objectFit?: Property.ObjectFit
  objectPosition?: Property.ObjectPosition
}) => {
  return (
    <NImage
      width={width}
      src={src}
      style={{
        objectFit: objectFit,
        objectPosition: objectPosition
      }}
      {...rest}
    />
  )
}

const Image = ({ src, width, size, ...rest }: ImageProps & {
  size?: number
}) => {
  return (
    <NImage
      width={width}
      src={`${src}?tx=c_scale,w_${width || size}`}
      unoptimized={true}
      {...rest}
    />
  )
}

export default Image
